(function ($) {
  $(document).ready(function () {
    // Add class to body when scrolling to add white background
    var targetDiv = $("body");

    $(window).scroll(function () {
      var windowpos = $(window).scrollTop();

      // change amount here to choose distance from top to add class
      if (windowpos >= 100) {
        targetDiv.addClass("scrolling-active");
      } else {
        targetDiv.removeClass("scrolling-active");
      }
    });
    //$(window).scroll(function () {
    //location.reload();
    //});
  });
})(jQuery);